import React from 'react';
import {getCatalogFilterStoreByProductType} from '../../_flux/stores/catalog_filter_store/factory';
import PostcodeStore from '../../_flux/stores/postcode_store';
import {filtersToStatusbarStatus} from '../../_flux/helper/filters_to_statusbar_status';
import StatusbarConstants from '../../_flux/constants/statusbar_constants';
import StatusbarComponent from '../../_flux/components/statusbar/desktop/statusbar';
import {openAction as openTyreIndexExplanationAction} from '../../_flux/actions/tyre_index_explanation_lightbox_actions';
import * as CatalogStatusbarGoogleAnalytics from '../../_modules/google_analytics/catalog/statusbar';
import {handleView} from '../handle_view';
import {onChangeSpecific} from './on_change_specific';

const stores = {
    postcodeState: PostcodeStore,
};

const render = ({catalogFilter, postcodeState}, {displayDimensions}) => (
    <StatusbarComponent
        status={filtersToStatusbarStatus(catalogFilter, postcodeState.postcodeExistsButNeedsToBeLoaded)}
        filters={catalogFilter}
        postcodeExistsButNeedsToBeLoaded={postcodeState.postcodeExistsButNeedsToBeLoaded}
        onChangeSpecific={onChangeSpecificClick}
        onAddMissingClick={onStatusBarAddMissingClick(catalogFilter)}
        onLearnMoreClick={openTyreIndexExplanationAction}
        displayDimensions={displayDimensions}
    />
);

export const init = (container, options) => {
    stores.catalogFilter = getCatalogFilterStoreByProductType(options.productType);
    return handleView(stores, render, options, container);
};

const onChangeSpecificClick = sections => {
    onChangeSpecific(sections);
    CatalogStatusbarGoogleAnalytics.changeSpecific(sections);
};

const all = ['sizes', 'indexes', 'postcode'];
const indexesAndPostcode = ['indexes', 'postcode'];
const postcode = ['postcode'];

const onStatusBarAddMissingClick = (catalogFilter) => () => {
    const status = filtersToStatusbarStatus(catalogFilter);

    const sectionsToChange =
        status === StatusbarConstants.ALL_MISSING ? all
            : status === StatusbarConstants.DIMENSIONS_MISSING ? all
            : status === StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING ? indexesAndPostcode
                : status === StatusbarConstants.SPEED_INDEX_MISSING ? indexesAndPostcode
                    : status === StatusbarConstants.LOAD_INDEX_MISSING ? indexesAndPostcode
                        : status === StatusbarConstants.TYRE_INDEX_MISSING ? indexesAndPostcode
                            : status === StatusbarConstants.POSTCODE_MISSING ? postcode
                                : undefined;

    onChangeSpecific(sectionsToChange);
    CatalogStatusbarGoogleAnalytics.addMissing(sectionsToChange);
};
